export enum LivestreamRouteName {
    Livestreams = 'livestreams',
    Detail = 'livestreams-detail',
    Join = 'livestreams-join',
    Create = 'livestreams-create',
    Edit = 'livestreams-edit',
    Summary = 'livestreams-summary'
}
